import { Fragment, useMemo } from 'react';
import { WarehouseProps } from 'componentsV2/product/details/content/subpages';
import InfoIcon from '@material-ui/icons/Info';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';

import { TabContentWrapper } from '../styled';
import { useWarehouseColumns } from './useWarehouseColumns';
import { MobileCard } from '../../../list/components/product-card/styled';

export const MobileWarehouse = ({
  configColumns = [],
  product,
  selectedCustomer
}: WarehouseProps) => {
  const { warehouseColumns } = useWarehouseColumns({
    selectedCustomer,
    configColumns,
    stockInfo: product?.stockInfo
  });

  const content = useMemo(() => {
    if (product?.dropship)
      return (
        <Box mt={3}>
          <Alert severity="info" icon={<InfoIcon />}>
            This item is Dropshipped. It will be directly shipped to the
            customer. Stock availability may not be available for dropshipped
            items.
          </Alert>
        </Box>
      );

    if (!product?.inventory?.length)
      return (
        <Box flex={1} display="flex">
          <ProductsEmptyState title="No Inventory Available" />
        </Box>
      );

    return (
      <Box
        flex={1}
        overflow="auto"
        display="flex"
        flexDirection="column"
        gridGap={8}>
        {product.inventory.map(inventory => (
          <MobileCard key={inventory._id}>
            {warehouseColumns.map(column => (
              <Fragment key={column.id}>
                {column.cellContent(inventory)}
              </Fragment>
            ))}
          </MobileCard>
        ))}
      </Box>
    );
  }, [product?.dropship, product.inventory, warehouseColumns]);

  return <TabContentWrapper>{content}</TabContentWrapper>;
};
